import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "error"]
  static values = { message: String }

  validate() {
    const input = this.inputTarget
    const value = input.value

    // Clear any custom validity set by a previous call BEFORE checking
    // checkValidity(), otherwise it would still see last render's stale error.
    input.setCustomValidity("")

    const tooShort = input.minLength > 0 && value.length > 0 && value.length < input.minLength
    const valid = value === "" || (input.checkValidity() && !tooShort)

    // Keep the native constraint validation API in sync (covers Safari/Firefox
    // quirks where "minlength" is only enforced after a real keystroke) so
    // form submission is blocked consistently, not just the inline message.
    if (tooShort) input.setCustomValidity(this.messageValue || "Valor muito curto")

    this.errorTarget.textContent = valid ? "" : (this.messageValue || input.validationMessage)
    this.errorTarget.classList.toggle("hidden", valid)
    input.classList.toggle("border-red-500", !valid)
    input.classList.toggle("focus:ring-red-500", !valid)
    input.classList.toggle("focus:border-red-500", !valid)
  }
}
